export default __webpack_public_path__ + "45c8dfe.png";